module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (112).2a726bc1.jpg";